import { ParishDto, FetchParishesByCountyIdCommand } from '@/Application/Localization/Parish'
import { CountyCode } from '@/Domain/Localization/County'
import { ParishRepository } from '@/Domain/Localization/Parish'

export class FetchParishesByCountyIdCommandHandler {
  private _repository: ParishRepository

  constructor (repository: ParishRepository) {
    this._repository = repository
  }

  async handle (command: FetchParishesByCountyIdCommand): Promise<ParishDto[]> {
    try {
      const countyId = new CountyCode(command.countyId())
      const parishes = await this._repository.byCountyId(countyId)
      return parishes.map(current => ParishDto.fromParish(current))
    } catch (error) {
      return Promise.reject(error)
    }
  }
}
